import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { apiGetAllCustomerWithDevice } from '@services/ManageCustomers/CustomerServices';
import React, { useEffect, useState } from 'react';
import OpenLayersMap from './components/Maps';
import { usePermission } from '@contexts/Auth/UsePermission';
import Page403 from '@page/Common/403/403';
import FilterAdvanceDrawer from '@components/FilterAdvance';
import { Skeleton } from 'antd';

const SKELETON_MARKERS = [
  { top: '16%', left: '18%' },
  { top: '18%', left: '44%' },
  { top: '22%', left: '68%' },
  { top: '25%', left: '22%' },
  { top: '34%', left: '34%' },
  { top: '36%', left: '78%' },
  { top: '42%', left: '48%' },
  { top: '48%', left: '16%' },
  { top: '63%', left: '31%' },
  { top: '54%', left: '72%' },
  { top: '62%', left: '56%' },
  { top: '70%', left: '82%' },
  { top: '76%', left: '60%' },
  { top: '82%', left: '38%' }
];

export const Maps = () => {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [keyWord, setKeyWord] = useState('');
  const [deviceStatus, setDeviceStatus] = useState(undefined);
  const [installationStatus, setInstallationStatus] = useState(undefined);
  const [warningStatus, setWarningStatus] = useState(undefined);
  const [dataFilterAdvance, setDataFilterAdvance] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [flagSearch, setFlagSearch] = useState(false);
  const { map } = usePermission();

  const fetch = async (overrides = {}) => {
    try {
      setLoading(true);
      const nextKeyWord = 'keyWord' in overrides ? overrides.keyWord : keyWord;
      const nextDeviceStatus = 'deviceStatus' in overrides ? overrides.deviceStatus : deviceStatus;
      const nextInstallationStatus =
        'installationStatus' in overrides ? overrides.installationStatus : installationStatus;
      const nextWarningStatus =
        'warningStatus' in overrides ? overrides.warningStatus : warningStatus;
      const res = await apiGetAllCustomerWithDevice({
        keyWord: nextKeyWord || undefined,
        device_status: nextDeviceStatus,
        installation_status: nextInstallationStatus,
        warning_status: nextWarningStatus,
        ...dataFilterAdvance
      });
      const convertData = res?.data?.data?.length
        ? res?.data?.data?.map((cust) => ({
            id: cust?.id || '',
            name: cust?.name || '',
            code: cust?.code || '',
            address: cust?.address || '',
            lat: cust?.latitude || '',
            lng: cust?.longitude || '',
            serial_no: cust?.device_information?.serial_no,
            model: cust?.device_information?.model,
            meter_reading: cust?.device_information?.meter_reading,
            device_id: cust?.device_information?.id,
            status: cust?.device_information?.status,
            last_seen_at: cust?.device_information?.last_seen_at,
            rsrp: cust?.device_information?.rsrp,
            snr: cust?.device_information?.snr,
            battery_capacity: cust?.device_information?.battery_capacity,
            alarm_status: cust?.device_information?.alarm_status
          }))
        : [];
      setCustomers(convertData);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const onSearch = (value) => {
    setKeyWord(value);
    fetch({ keyWord: value });
  };

  const onFilterChange = (name, value) => {
    const overrides = {};
    if (name === 'deviceStatus') {
      setDeviceStatus(value);
      overrides.deviceStatus = value;
    } else if (name === 'installationStatus') {
      setInstallationStatus(value);
      overrides.installationStatus = value;
    } else if (name === 'warningStatus') {
      setWarningStatus(value);
      overrides.warningStatus = value;
    }
    fetch(overrides);
  };

  useEffect(() => {
    fetch();
  }, [flagSearch]);

  if (!map.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <OpenLayersMap
          markers={customers}
          onSearch={onSearch}
          onFilterChange={onFilterChange}
          onOpenAdvanced={() => setIsOpen(true)}
          deviceStatus={deviceStatus}
          installationStatus={installationStatus}
          warningStatus={warningStatus}
        />
        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              zIndex: 10,
              background: 'rgba(255, 255, 255, 0.35)',
              pointerEvents: 'none'
            }}>
            {SKELETON_MARKERS.map((position, index) => (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  width: 36,
                  height: 46,
                  transform: 'translate(-50%, -100%)',
                  ...position
                }}>
                <Skeleton.Node
                  active
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: '50% 50% 50% 0',
                    transform: 'rotate(-45deg)'
                  }}>
                  <span
                    style={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      background: 'var(--surface)',
                      display: 'block'
                    }}
                  />
                </Skeleton.Node>
              </div>
            ))}
          </div>
        )}
      </div>
      <FilterAdvanceDrawer
        isOpen={isOpen}
        onDrawerClose={() => setIsOpen(false)}
        dataFilterAdvance={dataFilterAdvance}
        setDataFilterAdvance={setDataFilterAdvance}
        flagSearch={flagSearch}
        setFlagSearch={setFlagSearch}
      />
    </>
  );
};
